import React, {useState} from "react";
import Liver from "../../../assets/images/organs/72x72/Liver_Up_72x72.png";
import LiverHover from "../../../assets/images/organs/72x72/Liver_Over_72x72.png";
function LiverIcon(props) {
    const [isHover, setIsHover] = useState(false);

    if (props.showHover) {
        return (
            <div 
                className={props.count ? "icon-container organ-count-wrapper" : "icon-container"}
                onMouseEnter={()=> setIsHover(true)}
                onMouseLeave={()=> setIsHover(false)}
            >
                <img src={isHover ? LiverHover : Liver} alt="Liver Icon" className="organ-icon" />
                {props.count &&
                    <div className="organ-count liver">
                        {props.count}
                    </div>
                }
            </div>
        );
    }
    else {
        return (<img src={Liver} alt="Liver Icon" className="organ-icon" />);
    }
}

export default LiverIcon;